<script>
	export default {
		name: 'TimelineExecuter',
		methods: {
			selectTimeline(type, key) {
				const self_ = this;

				const timeline_ =  self_.getPageState('timeline')

				timeline_.type = type;
				timeline_.key = key;

				return new Promise(resolve => {
					self_.setPageState('timeline', timeline_)
					resolve()
				})
			},
			timelineIsSelected(type, key, sender, to) {
				const self_ = this;
				
				if (type == '' || key == '' || sender == '' || to == []) { return false }

				const uid_ = self_.getCurrentUser('uid')

				// not selected any type & key
				if (self_.currentTimelineType == '' && self_.currentTimelineKey == '') {
					if (type == 'chat') {
						if (sender == uid_) { 
							return true }
						else {
							let res_ = false;
							to.forEach(uid => {
								if (uid == uid_) { 
									res_ = true }
							})
							return res_
						}		
					} else { return true }
				}
				// chat is selected
				else if (self_.currentTimelineType == 'chat') {
					if (type == 'chat' && key == self_.currentTimelineKey) {
						return	sender == uid_ ||
								to == uid_
					}
				}
				// other type is selected
				else {
					return	self_.currentTimelineType == type &&
							self_.currentTimelineKey == key
				}
				return false
			}
		}
	}
</script>